export default __webpack_public_path__ + "static/roberty-79cd265dee81109acd4d72dd3efdecd2.png";